import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import lodash from 'lodash';

const SelectBase = (props) => {
   // If the initial "value" prop is not an object, then this 'value' prop is the "value" property of an option.
   // Updates the "value" prop to be the option with option.value === prop.value
   useEffect(() => {
      if (props.isLoading === false && !lodash.isObject(props.value) && lodash.isArray(props.options)) {
         const optionMatch = props.options.find((option) => (option?.value === props.value));
         if (optionMatch) {
            props.onChange(optionMatch);
         }
      }
   }, [props.isLoading]);

   return (
      <Select
         value={props.value === undefined ? null : props.value}
         options={props.options}
         isSearchable={props.isSearchable}
         isLoading={props.isLoading}
         onChange={props.onChange}
         isDisabled={props.isDisabled}
         onBlur={props.onBlur}
         classNamePrefix='react-select'
         className={`react-select-container ${ props.className }`}
         isOptionDisabled={props.isOptionDisabled}
         isOptionSelected={props.isOptionSelected}
         isClearable={props.isClearable}
         placeholder={props.placeholder}
      />
   );
};

SelectBase.propTypes = {
   value: PropTypes.oneOfType([
      PropTypes.shape({
         label: PropTypes.string.isRequired,
         value: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string,
            PropTypes.number,
         ]).isRequired,
      }),
      PropTypes.string,
      PropTypes.number,
   ]),
   // Func that takes in the new value as only arg
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
         PropTypes.object,
         PropTypes.string,
         PropTypes.number,
      ]),
   })),
   isDisabled: PropTypes.bool,
   isSearchable: PropTypes.bool,
   isLoading: PropTypes.bool,
   className: PropTypes.string,
   isOptionSelected: PropTypes.func,
   isOptionDisabled: PropTypes.func,
   isClearable: PropTypes.bool,
   placeholder: PropTypes.string,
};

SelectBase.defaultProps = {
   value: undefined,
   onBlur: undefined,
   isDisabled: false,
   isSearchable: false,
   isLoading: false,
   options: [],
   className: '',
   isOptionSelected: undefined,
   isOptionDisabled: undefined,
   isClearable: false,
   placeholder: undefined,
};

export default SelectBase;
